import { Spinner } from "@phosphor-icons/react";

/**
 * Subtle centered loader used ONLY when a page has no cached data to show.
 * Repeat visits render cached content instantly and never see this.
 */
export default function PageLoader({ label = "Loading…", testid = "page-loader" }) {
  return (
    <div className="min-h-[40vh] w-full flex items-center justify-center"
         data-testid={testid}>
      <div className="flex items-center gap-3 label"
           style={{ color: "var(--text-dim)" }}>
        <Spinner size={18} weight="bold" className="animate-spin" />
        <span>{label}</span>
      </div>
    </div>
  );
}
